<template>
    <div class="pa-2">
        <v-alert
            type="success"
        >
            Imóvel excluído com sucesso!
        </v-alert>
    </div>
</template>

<script>
export default {
    name: 'PropertyDeleted',

    mounted() {
        window.scrollTo(0, 0);  
    }    
}
</script>